import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Input, Radio, Select, message } from "antd";
import { KEYS } from "./index";
import axios from "axios";
import localhost from "../../constants/localhost";

export default ({ mode, detail }) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [roleList, setRoleList] = useState([]);

  const getData = () => {
    const formData = form.getFieldsValue();
    axios
      .post(`${localhost}/manage/role/queryList`, {
        pageNo: 1,
        pageSize: 10000,
        ...formData,
      })
      .then((res) => {
        setRoleList(res.data.list);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!visible) {
      return;
    }
    getData();
  }, [visible]);

  const modalTitle = "新增用户";
  const operationText = "新增用户";

  return (
    <>
      {mode === "create" && (
        <Button
          type="primary"
          onClick={() => setVisible(true)}
          style={{ marginRight: 16 }}
        >
          {operationText}
        </Button>
      )}
      {mode === "edit" && (
        <a
          onClick={() => {
            setVisible(true);
            form.setFieldsValue(detail);
          }}
        >
          编辑
        </a>
      )}

      <Modal
        title={modalTitle}
        open={visible}
        onCancel={() => {
          setVisible(false);
        }}
        onOk={() => {
          // 提交表单
          form
            .validateFields()
            .then((values) => {
              axios
                .post(`${localhost}/manage/user/save`, values)
                .then((res) => {
                  message.success(
                    `${mode === "edit" ? "编辑" : "新增"}内容成功！`
                  );
                  setVisible(false);
                  // getData();
                })
                .catch((error) => {
                  message.error("网络异常，请重试！");
                });
            })
            .catch((err) => {
              console.log("err", err);
            });
        }}
      >
        <Form
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          form={form}
          name="create-user"
        >
          <Form.Item
            label="姓名"
            name={KEYS.NAME}
            rules={[{ required: true, message: "请填写姓名" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="手机号"
            name={KEYS.PHONE}
            rules={[{ required: true, message: "请填写手机号" }]}
          >
            <Input type="phone" />
          </Form.Item>
          <Form.Item
            label="性别"
            required
            name={KEYS.SEX}
            rules={[{ required: true, message: "请选择手机号" }]}
          >
            <Radio.Group>
              <Radio value={1}>女</Radio>
              <Radio value={2}>男</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="部门"
            required
            name={KEYS.DEPARTMENT}
            rules={[{ required: true, message: "请填写部门" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="角色" name={KEYS.ROLE}>
            <Select>
              {roleList.map(({ name, code }) => {
                return <Select.Option value={code}>{name}</Select.Option>;
              })}
            </Select>
          </Form.Item>
          <Form.Item label="归属地" name={KEYS.CITY}>
            <Input />
          </Form.Item>
          <Form.Item label="喜好" name={KEYS.LOVE}>
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
